export enum RoutesEnum {
  authResponse = "/auth/response",
  home = "/",
  privacyPolicy = "/privacy-policy",
  termsOfService = "/terms-of-service",
  imprint = "/imprint",
  signin = "/sign-in",
  profile = "/profile",
  redeemCode = "/code",
  howToDeleteMyAccount = "/how-to-delete-my-account",
  appleHealthWriteErrorGuide = "/apple-health-write-error-guide",
  emailVerificationResponse = "/email-verification-response",
  soundscapes = "/soundscapes/*",
  collections = "/collections/*",
  exercises = "/exercises/*",
  minddrops = "/minddrops/*",
  faq = "/faq",
  resetPassword = "/reset-password",
  updatePassword = "/update-password",
  shop = "/shop",
  paymentResponse = "/payment-response",
}
